import { Component, Input } from '@angular/core';
import { LoadingService } from '../../core/services/loading/loading.service';
import { DinamicoService } from '../../service/dinamico.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {
  @Input() logoPath: string = '';
  isLoading$: Observable<boolean>;

  constructor(
    private loadingService: LoadingService, 
    private dinamicoService: DinamicoService
  ) {
    this.isLoading$ = this.loadingService.isLoading$;
    this.logoPath = this.dinamicoService.getLogo();
  }
}

